module.exports = __webpack_public_path__ + "media/images/icons/tools-dc57d7935d9cd2aabd96ef2e91f46354.svg";